// app/javascript/paxsudos/auto_attach_by_url_runtime.js
// Auto-attach URL → probe/fetch ilman sivun refreshiä.
// Ei tuplakuuntelijoita, toimii SPA-route-vaihdoissa.

(() => {
  const ATTACHED = new WeakMap();
  const SELS = [
    '.compose-form textarea',
    'form[role="textbox"] textarea',
    'textarea.autosuggest-textarea__textarea',
    'textarea#status_content',
  ];

  const log = (...a) => console.info('[upload-by-url]', ...a);

  // Etsi textarea
  const findTextarea = () => {
    for (const s of SELS) {
      const el = document.querySelector(s);
      if (el) return el;
    }
    return null;
  };

  const extractUrls = (s) => {
    if (!s) return [];
    const re = /https?:\/\/[^\s<>"']+/gi;
    return Array.from(new Set((s.match(re) || []).map(x => x.trim())));
  };

  const api = {
    // säädä polut tarvittaessa
    probe: (url) => fetch(`/upload-by-url/probe?url=${encodeURIComponent(url)}`, { credentials: 'same-origin' }),
    fetch: (url) => fetch(`/upload-by-url/fetch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ url, embed: true }),
    }),
  };

  const attach = (ta) => {
    if (!ta || ATTACHED.get(ta)) return;
    const state = { last: [] };

    const handle = async (urls) => {
      if (!urls.length) return;
      log('found urls:', urls);
      // nopea probe joka näyttää onko URL kelvollinen
      try {
        await api.probe(urls[0]);
      } catch (e) {
        console.warn('[upload-by-url] probe failed', e);
      }
    };

    const onPaste = (e) => {
      const t = (e.clipboardData?.getData('text') || '').trim();
      const urls = extractUrls(t);
      if (urls.length) {
        // estä raaka-URLin liittäminen jos haluat
        // e.preventDefault();
        handle(urls);
      }
    };

    let deb;
    const onInput = () => {
      clearTimeout(deb);
      deb = setTimeout(() => {
        const urls = extractUrls(ta.value);
        if (urls.length && urls.join(' ') !== state.last.join(' ')) {
          state.last = urls;
          handle(urls);
        }
      }, 200);
    };

    ta.addEventListener('paste', onPaste);
    ta.addEventListener('input', onInput);
    ATTACHED.set(ta, true);
    log('listener attached');
  };

  const ensureAttached = () => {
    const ta = findTextarea();
    if (ta) attach(ta);
  };

  // 1) heti kun DOM on valmis
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureAttached, { once: true });
  } else {
    ensureAttached();
  }

  // 2) SPA-vaihdokset: tarkkaile DOM:ia
  const mo = new MutationObserver(() => ensureAttached());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 3) varmistus turboa/Historyä varten
  window.addEventListener('popstate', ensureAttached);
  window.addEventListener('pushstate', ensureAttached);
})();

